import { MART_SEARCH_RESULT_TYPE } from '@shopee/search-common-util';
import { hasSearchFilter } from '@shopee/search-filter-util';
import PROGRESS from '@shopee/api-progress';

// Types
import type { SearchParams } from '@shopee/search-common-util';
import type {
  MartSearchResult,
  MartSearchQueryRewrite,
} from '@shopee/mart-search-items-redux';

const NON_REWRITE_RESULT_TYPES: MART_SEARCH_RESULT_TYPE[] = [
  MART_SEARCH_RESULT_TYPE.NO_RESULT,
  MART_SEARCH_RESULT_TYPE.NO_RESULT_FILTER,
  MART_SEARCH_RESULT_TYPE.ERROR,
  MART_SEARCH_RESULT_TYPE.LOADING,
];

export function getResultType({
  searchParams,
  searchResult,
}: {
  searchParams: SearchParams;
  searchResult: MartSearchResult | void;
}): MART_SEARCH_RESULT_TYPE {
  if (!searchResult) {
    /** NOTE: If searchResult doesn't exist, we assume the fetch request
     * has not been sent yet, so we consider it a normal result type
     * instead of no result
     */
    return MART_SEARCH_RESULT_TYPE.NORMAL;
  }

  let resultType = searchResult.query_rewrite.fe_query_write_status;

  // if result items is empty, set to no result as default
  if (searchResult.progress === PROGRESS.OK && searchResult.total_count === 0) {
    resultType = MART_SEARCH_RESULT_TYPE.NO_RESULT;
  }

  const hasFilter = hasSearchFilter(searchParams);
  if (resultType === MART_SEARCH_RESULT_TYPE.NO_RESULT && hasFilter) {
    resultType = MART_SEARCH_RESULT_TYPE.NO_RESULT_FILTER;
  }

  // NOTE: This is to handle query rewrite cases.
  if (
    searchParams.originalResultType &&
    !NON_REWRITE_RESULT_TYPES.includes(resultType)
  ) {
    resultType = searchParams.originalResultType;
  }

  return resultType;
}

export function getQueryRewrittenSearchParams({
  searchParams,
  queryRewrite,
  resultType,
}: {
  searchParams: SearchParams;
  queryRewrite: MartSearchQueryRewrite;
  resultType: MART_SEARCH_RESULT_TYPE;
}): SearchParams {
  if (resultType === MART_SEARCH_RESULT_TYPE.NO_RESULT_EXPLICIT) {
    return {
      ...searchParams,
      complementKeyword: searchParams.keyword,
      keyword: queryRewrite.rewrite_keyword || void 0,
      originalResultType: resultType,
    };
  }
  return {
    ...searchParams,
    complementKeyword: queryRewrite.rewrite_keyword || void 0,
    originalResultType: resultType,
  };
}
